import React from 'react';
import Navigation from '../components/navigation';
import Header from '../components/header';
import Features from '../components/features';
import About from '../components/about';
import Team from '../components/Team';
import Contact from '../components/contact';
import * as data from '../data.json';

export default function Home () {
  return (
    <div>
      <Navigation />
      <Header data={data.Header} />
      <Features data={data.Features} />
      <About data={data.About} />
      <Team data={data.Team} />
      <Contact data={data.Contact} />
    </div>
  );
}
